import dayjs from 'dayjs';

import { getEnTranslation, getFrTranslation } from 'utils';

import { retailerStore, retailerStoreValues } from './retailerStore';
import { IRetailerStoreActions } from './types';

export const initRetailerSuccessAction: IRetailerStoreActions['initRetailerSuccessAction'] = (data) => {
  const {
    name,
    status,
    company,
    regions,
    sponsorCode,
    effectiveTo,
    effectiveFrom,
    translations,
    isContainPii,
    imageMetadataId,
    isEnabledBaseIssuance,
    baseIssuanceProductExclusions,
    isExcludedFromCompanyPostProcessors,
  } = data;

  retailerStore.setState({
    name,
    status,
    imgId: imageMetadataId,
    baseIssuanceProductExclusions,
    initialValues: {
      enValues: getEnTranslation(translations),
      frValues: getFrTranslation(translations),
      retailerValues: {
        regions,
        isExcludedFromCompanyPostProcessors,
        companyId: company.id,
        isContainPii: !!isContainPii,
        effectiveTo: effectiveTo && dayjs(effectiveTo) as unknown as string,
        effectiveFrom: effectiveFrom && dayjs(effectiveFrom) as unknown as string,
      },
      partnerValues: {
        sponsorCode,
        isEnabledBaseIssuance,
        manualThreshold: undefined,
        isManualThreshold: false,
      },
    },
  });
};

export const setProductExclusionsAction: IRetailerStoreActions['setProductExclusionsAction'] = (productExclusions) => {
  retailerStore.setState({
    baseIssuanceProductExclusions: productExclusions,
  });
};

export const resetRetailerStoreAction: IRetailerStoreActions['resetRetailerStoreAction'] = () => {
  retailerStore.setState(retailerStoreValues);
};
